import { __assign } from "tslib";
import { ApiTypes } from '../../types';
import { MemberDTO } from './MemberDTO';
import { GroupMember } from './GroupMember';
import { PrivacyStatusStatus, } from '@wix/ambassador-members-ng-api/types';
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export function isAnonymous(member) {
    var _a;
    return member === Anonymous || !member.siteMemberId || !((_a = member.name) === null || _a === void 0 ? void 0 : _a.nick);
}
export function isGroupMember(member) {
    return (member.relationship &&
        member.relationship !== ApiTypes.v1.RelationshipWithGroup.NONE);
}
export var Anonymous = {
    imageUrl: null,
    joinedOn: null,
    name: { nick: null },
    relationship: ApiTypes.v1.RelationshipWithGroup.NONE,
    requestedMembershipOn: null,
    roles: [],
    siteMemberId: null,
};
export function isProfilePublic(member) {
    return member.privacyStatus === PrivacyStatusStatus.PUBLIC;
}
export function memberWrapper(member) {
    return __assign(__assign({}, Anonymous), member);
}
export function sortMembersByName(members, order) {
    return members.sort(function (m1, m2) {
        var memberDTO1 = new MemberDTO(m1);
        var memberDTO2 = new MemberDTO(m2);
        var desc = order === SortOrder.DESC ? -1 : 1;
        return memberDTO1.compareName(memberDTO2) * desc;
    });
}
export function filterMembersByRole(members, role) {
    return members.filter(function (m) {
        var member = new GroupMember(m);
        return member.hasRole(role);
    });
}
export function filterMembersByName(members, name) {
    return members.filter(function (m) {
        var member = new GroupMember(m);
        var pattern = new RegExp(name, 'i');
        return pattern.test(member.getName());
    });
}
export function memberNames(members, anon) {
    return members.map(function (m) { return new MemberDTO(m).getName(anon); });
}
//# sourceMappingURL=Member.js.map